"use client";

import Image from "next/image";

/* A single ad-creative tile: either a lifestyle photo, a bold typographic
   creative, or a product-on-gradient. Built in CSS so it reads as a real
   "campaign wall" without depending on bespoke artwork. */
const tiles = [
  { type: "label", label: "//COURT GRAFFIK", from: "#1a1a1a", to: "#000" },
  {
    type: "photo",
    src: "/assets/homePage/testimonial/female-1.jpeg",
    caption: "love, in every little detail.",
  },
  { type: "label", label: "//STAG", from: "#2e3b2a", to: "#141d11" },
  { type: "grad", from: "#0b2a4a", to: "#06121f", caption: "ENGRAVED FOR YOUR VIBE" },
  {
    type: "photo",
    src: "/assets/homePage/testimonial/male-1.jpeg",
    caption: "Found that keeps you Fed.",
  },
  { type: "label", label: "PRIVATE SALE", from: "#101010", to: "#2b2b2b" },
  {
    type: "photo",
    src: "/assets/homePage/testimonial/female-2.jpeg",
    caption: "Effortless sparkle. Everyday you.",
  },
  { type: "label", label: "LEGENDS NEVER STOP", from: "#3a0d0d", to: "#1a0606" },
  { type: "grad", from: "#1d3a3f", to: "#0a1719", caption: "SOUND THAT STAYS WITH YOU." },
  {
    type: "photo",
    src: "/assets/homePage/testimonial/male-2.jpeg",
    caption: "SOUND THAT FUELS EVERY WIN.",
  },
  { type: "label", label: "BUILT FOR MOVERS.", from: "#f0ede6", to: "#d8d2c6", dark: true },
  { type: "grad", from: "#1c2336", to: "#0a0f1c", caption: "DEEP BASS" },
];

const Tile = ({ tile }) => {
  if (tile.type === "photo") {
    return (
      <div className="group relative mb-3 overflow-hidden rounded-xl shadow-md break-inside-avoid">
        <Image
          src={tile.src}
          alt=""
          width={300}
          height={380}
          className="h-auto w-full object-cover"
        />
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-3">
          <p className="font-kalam text-sm font-bold text-white">
            {tile.caption}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div
      className="mb-3 flex aspect-[4/5] flex-col justify-end overflow-hidden rounded-xl p-4 shadow-md break-inside-avoid"
      style={{
        backgroundImage: `linear-gradient(135deg, ${tile.from}, ${tile.to})`,
      }}
    >
      <p
        className={`text-lg font-extrabold uppercase leading-tight tracking-tight ${
          tile.dark ? "text-[#242424]" : "text-white"
        }`}
      >
        {tile.label ?? tile.caption}
      </p>
    </div>
  );
};

const StudioCampaigns = () => {
  return (
    <section className="bg-[#F5F5F7] px-5 py-16 sm:px-6 sm:py-20 lg:px-20 lg:py-24">
      <h2 className="mx-auto mb-10 max-w-3xl text-center text-[26px] font-medium leading-[1.15] tracking-[-0.5px] text-[#242424] sm:text-[34px] lg:text-5xl 3xl:text-[64px]">
        Turn products into{" "}
        <span className="text-[#3232A4]">studio-quality</span> campaigns
      </h2>

      <div className="mx-auto w-full max-w-[1100px] [column-fill:_balance] columns-2 gap-3 sm:columns-3 lg:columns-4">
        {tiles.map((tile, i) => (
          <Tile key={i} tile={tile} />
        ))}
      </div>
    </section>
  );
};

export default StudioCampaigns;
